import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "../api/api";

export default function AnnouncementStrip() {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    const fetchLatestAnnouncement = async () => {
      try {
        const res = await api.get("/announcements/latest");
        setAnnouncement(res.data);
      } catch (error) {
        console.error("Failed to fetch latest announcement:", error);
      }
    };

    fetchLatestAnnouncement();
  }, []);

  if (!announcement) return null;

  return (
    <section className="w-full bg-[#F4D300] py-4">
      <div className="max-w-7xl mx-auto px-5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-[#061A40] font-black text-sm md:text-base">
          Announcement
        </div>

        <Link
          to={`/publications/announcements/${announcement.slug}`}
          className="inline-flex items-center justify-center gap-2 bg-[#061A40] text-white px-6 py-3 rounded-md font-black text-xs md:text-sm hover:bg-[#0A2A62] transition-all duration-300 shadow-lg"
        >
          <span>{announcement.title}</span>
          <ChevronRight size={18} />
        </Link>
      </div>
    </section>
  );
}